<template>
  <Form inline @submit.native.prevent v-if="isAdminRole">
    <FormItem label="显示所有租户" :label-width="90">
      <i-switch v-model="all_tenants" @on-change="callback">
        <span slot="open"></span>
        <span slot="close"></span>
      </i-switch>
    </FormItem>
  </Form>
</template>

<script>
import { getPrivateCloudProjectIsAdminRole } from '@/api/private-cloud/project'
export default {
  name: 'allTenantSwitch',
  data () {
    return {
      isAdminRole: false,
      all_tenants: false
    }
  },
  mounted: function () {
    this.getIsAdminRole()
  },
  methods: {
    callback () {
      this.$emit('callback')
    },
    // 判断用户在租户中是否为admin角色
    getIsAdminRole () {
      if (this.$store.state.privateCloud.selPrivateCloudProject) {
        getPrivateCloudProjectIsAdminRole(this.$store.state.privateCloud.selPrivateCloudProject).then(res => {
          this.isAdminRole = res.data.is_admin
        }).then(res => {
          this.isAdminRole = false
        })
      }
    },
    allTenants () {
      return this.isAdminRole && this.all_tenants
    }
  }
}
</script>

<style scoped>

</style>
